import type { CaptureResult } from "posthog-js/dist/module.slim";

/**
 * posthog-js `before_send`: a $pageview for the path the previous one already
 * covered is the same page counted twice. The router only fires on path
 * changes, but a redirect that lands before the SDK finishes loading still
 * produces the router's pageview and the SDK's initial one for the same page,
 * in either order — this is the one place that sees both.
 */
export const createRepeatPageviewFilter = () => {
  let lastPathname: string | undefined;

  return (event: CaptureResult | null): CaptureResult | null => {
    if (event?.event !== "$pageview") return event;
    const pathname = event.properties["$pathname"];
    if (typeof pathname !== "string") return event;
    if (pathname === lastPathname) return null;
    lastPathname = pathname;
    return event;
  };
};
